/* eslint no-prototype-builtins: 0 */
import { applyJQueryXsrf } from './xsrf';

/**
 * Executes a jQuery POST
 * @deprecated Use Axios. import axios from '@/script/common/axios-utils' will provide
 * an axios instance which supports application-required interceptors (XSRF, session expiry)
 */
export function jQueryPostJson (url: string, data: any, token?: string) {
	if (typeof data !== 'string') {
		data = JSON.stringify(data);
	}

	const request = {
		type: 'POST',
		url,
		data,
		dataType: 'json',
		contentType: 'application/json; charset=utf-8'
	};

	applyJQueryXsrf(request);

	return $.ajax(request);
}

/**
 * Executes a jQuery GET
 * @deprecated Use Axios. import axios from '@/script/common/axios-utils' will provide
 * an axios instance which supports application-required interceptors (XSRF, session expiry)
 */
export function jQueryGetJson (url: string, data: any, token?: string) {
	data = data || null;
	let useTraditional = false;
	// http://stackoverflow.com/questions/3676883/send-list-array-as-parameter-with-jquery-getjson
	if (data) {
		for (const prop in data) {
			if (data.hasOwnProperty(prop) && $.isArray(data[prop])) {
				useTraditional = true;
			}
		}
	}

	const request = {
		cache: false,
		dataType: 'json',
		url,
		data,
		traditional: useTraditional,
		contentType: 'application/json; charset=utf-8'
	};

	applyJQueryXsrf(request);

	return $.ajax(request);
}
